import { DatePipe } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { LegacyApiService } from '@lmc-app/core/services/legacy-api.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-mft-lpp4476',
  templateUrl: './mft-lpp4476.component.html',
  styleUrls: ['./mft-lpp4476.component.scss']
})
export class MftLpp4476Component implements OnDestroy {

  start_date: any;
  end_date: any;

  mftLPPDataSubscription: Subscription;
  MFTLPP_Report: any;

  //_Hist
  defaultColDef_Hist: any;
  public columnDefs_Hist = [];
  public rowData_Hist;
  public gridApi_Hist;
  public gridColumnApi_Hist;
  public defaultExcelExportParams;
  public defaultCsvExportParams;

  btnSpinner = false;
  btnShowText = true;

  constructor(private apiService: LegacyApiService, private datepipe: DatePipe) {
    //Payment History
    this.columnDefs_Hist = [
      { headerName: 'acctrefno', field: 'acctrefno', sortable: true, filter: 'agTextColumnFilter' },
      { headerName: 'loan_number', field: 'loan number', sortable: true, filter: 'agTextColumnFilter' },
      { headerName: 'Account Name', field: 'Account Name', sortable: true, filter: "agTextColumnFilter" },
      { headerName: 'Loan Group', field: 'Loan Group', sortable: true, filter: "agDateColumnFilter" },
      { headerName: 'Maturity Date', field: 'Maturity Date', sortable: true, filter: 'agDateColumnFilter' },
      { headerName: 'Status Code', field: 'Status Code', sortable: true, filter: 'agTextColumnFilter' },
      { headerName: 'Credit Score', field: 'Credit Score', sortable: true, filter: "agNumberColumnFilter" },
      { headerName: 'Orginal Loan Amount', field: 'Orginal Loan Amount', sortable: true, filter: 'agNumberColumnFilter' },
      { headerName: 'Insurance Premium', field: 'Insurance Premium', sortable: true, filter: 'agNumberColumnFilter' },
      { headerName: 'Ins tax', field: 'Ins tax', sortable: true, filter: "agNumberColumnFilter" },
      { headerName: 'Industry', field: 'Industry', sortable: true, filter: "agNumberColumnFilter" },
      { headerName: 'Payments Remaining', field: 'Payments Remaining', sortable: true, filter: 'agNumberColumnFilter' },
      { headerName: 'Principal Period', field: 'Principal Period', sortable: true, filter: 'agTextColumnFilter' },
      { headerName: 'Payoff Date', field: 'Payoff Date', sortable: true, filter: "agDateColumnFilter" },
      { headerName: 'Reg Payment', field: 'Reg Payment', sortable: true, filter: "agNumberColumnFilter" },
      { headerName: 'Open Date', field: 'Open Date', sortable: true, filter: 'agDateColumnFilter' },
      { headerName: 'State', field: 'State', sortable: true, filter: "agTextColumnFilter" },
      { headerName: 'Position', field: 'Position', sortable: true, filter: "agTextColumnFilter" },
      { headerName: 'LoanStatus', field: 'LoanStatus', sortable: true, filter: "agNumberColumnFilter" },
      { headerName: 'TDSR', field: 'TDSR', sortable: true, filter: "agTextColumnFilter" },
      { headerName: 'Setup Date', field: 'setup date', sortable: true, filter: "agDateColumnFilter" },
    ]
    this.defaultColDef_Hist = {
      resizable: true
    }
    this.defaultExcelExportParams = { fileName: 'mft_lpp_4476_' + this.datepipe.transform(new Date(), 'yyyy-MM-dd') + '.xlsx' };
    this.defaultCsvExportParams = { fileName: 'mft_lpp_4476_' + this.datepipe.transform(new Date(), 'yyyy-MM-dd') + '.csv' };
  }

  startDate(e) {
    this.start_date = e;
  }
  endDate(e) {
    this.end_date = e;
  }
  onGridReady_Hist(params) {
    this.gridApi_Hist = params.api;
    this.gridColumnApi_Hist = params.columnApi;
    this.gridApi_Hist.setRowData(this.MFTLPP_Report);
    this.rowData_Hist = this.MFTLPP_Report

  }

  downloadMFTLPP() {
    if (this.start_date > this.end_date)
      alert("Invalid Dates")
    else {
      this.btnSpinner = true;
      this.btnShowText = false;
      this.MFTLPP_Report = null;
      this.rowData_Hist = [];
      this.mftLPPDataSubscription = this.apiService.getMFTLPP4476(this.start_date, this.end_date).subscribe((res) => {
        console.log(res);
        this.MFTLPP_Report = res;
        this.gridApi_Hist.setRowData(this.MFTLPP_Report);
        this.rowData_Hist = this.MFTLPP_Report;
        this.btnSpinner = false;
        this.btnShowText = true;
      })
    }
  }

  ngOnDestroy() {
    this.mftLPPDataSubscription?.unsubscribe();
  }


}
